import React from 'react';
import { faqs } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Accordion } from './Accordion';
export function FaqSection() {
  return <section className="defer-paint bg-night px-5 py-10" data-id="element-46" data-mp="1phxh1e1j5m0v">
      <SectionTitle data-id="element-47" data-mp="1bltzak7uf65a">Preguntas Frecuentes</SectionTitle>

      <div className="mt-6 space-y-3" data-id="element-48" data-mp="1gjbznm7sod1o">
        {faqs.map((faq, i) => <Accordion key={faq.question} id={`faq-${i + 1}`} openClassName="bg-gold/[0.04]" header={<span className="flex items-start gap-3" data-id="element-50" data-mp="249ptni9xwlyw">
                <span className="font-display text-[17px] font-bold text-gold" data-id="element-51" data-mp="28bb46wz04o5x">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="font-sans text-[15px] font-medium leading-snug text-ivory" data-id="element-52" data-mp="1uj4p7e7l4n82">
                  {faq.question}
                </span>
              </span>} data-id="element-49" data-mp="1gjvid559r5gr" data-mpi={i}>
            <p className="font-sans text-[15px] leading-relaxed text-ivory/80" data-id="element-53" data-mp="2n70rqzju59cr">
              {faq.answer}
            </p>
          </Accordion>)}
      </div>
    </section>;
}